/**
 * GraphQL Query: GetHealth
 * Get API health and version information
 */
export const GET_HEALTH = `
  query GetHealth {
    health {
      status
      timestamp
      version
      environment
    }
  }
`;
//# sourceMappingURL=getHealth.js.map